import { createSlice } from "@reduxjs/toolkit";

const getAllClassPeriodTeacherscheduleSlice = createSlice({
  name: "classPeriodTeacherscheduleList",
  initialState: {
    classPeriodTeacherscheduleList : [],
    loading: false,
    error: null,
  },
  reducers: {
    getAllClassPeriodTeacherscheduleRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAllClassPeriodTeacherscheduleSuccess: (state, action) => {
      state.loading = false;
      state.classPeriodTeacherscheduleList = action.payload;
    },
    getAllClassPeriodTeacherscheduleFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearAllClassPeriodTeacherschedule: (state) => {
      state.classPeriodTeacherscheduleList = [];
      state.loading = false;
      state.error = null;
    },
    updateAddClassPeriodTeacherscheduleItem: (state, action) => {
      const { id, employeeID, fullName,  periodID, periodName, startTime, endTime, classID, className, sectionID, sectionName, streamID, streamName, subStreamID, subStreamName, subjectID, subjectName, modifiedAt } = action.payload;
      const normalizedId = id.toString().toLowerCase();
      const index = state.classPeriodTeacherscheduleList && state.classPeriodTeacherscheduleList.findIndex(item => {
        return (
          item.id.toString().toLowerCase()  === normalizedId
        )
      });
      if (index !== -1) {
        state.classPeriodTeacherscheduleList[index] = { ...state.classPeriodTeacherscheduleList[index], id, employeeID, fullName, periodID, periodName, startTime, endTime, classID, className, sectionID, sectionName, streamID, streamName, subStreamID, subStreamName, subjectID, subjectName, modifiedAt };
      } else {
        state.classPeriodTeacherscheduleList.push(action.payload);
      }
    },
    removeClassPeriodTeacherscheduleItem: (state, action) => {
       const normalized1Id = action.payload.id.toString().toLowerCase();
      state.classPeriodTeacherscheduleList = state.classPeriodTeacherscheduleList.filter(item => item.id.toString().toLowerCase() !== normalized1Id);
    },
  },
});

export const {
  getAllClassPeriodTeacherscheduleRequest,
  getAllClassPeriodTeacherscheduleSuccess,
  getAllClassPeriodTeacherscheduleFailure,
  clearAllClassPeriodTeacherschedule,
  updateAddClassPeriodTeacherscheduleItem,
  removeClassPeriodTeacherscheduleItem
} = getAllClassPeriodTeacherscheduleSlice.actions;

export default getAllClassPeriodTeacherscheduleSlice.reducer;
